import React from 'react'
import Markdown from 'react-markdown'
// import gfm from 'remark-gfm';
import LinkRenderer from './LinkRenderer'

// remarkPlugins={[gfm]}

const SmartMarkdown = ({ children, ...props }) => (
  <Markdown components={{ a: LinkRenderer }} {...props}>
    {children && children.replace(/\.\./g, '.')}
  </Markdown>
)

export default SmartMarkdown
